export default {
  props: {
    product: Object,
    productResources: Map,
    resourceTypes: Array,
  },
  methods: {
    resourceClassName: function ( extension ) {
      const ext = extension.toLowerCase();
      const mimeTypeToClass = { pdf: 'btn-pdf', zip: 'btn-zip' };
      return mimeTypeToClass[ext];
    },
    navigateToProduct: function () {
      location = this.product.url;
    }
  },
  template: `
    <tr>
      <th scope='row' @click="navigateToProduct()" class="product-link">
        <span>
          <img
            :src="product.image_src || product.image"
            sizes="(max-width: 34em) 84.926vw, (max-width: 46.875em) 85.067vw, (max-width: 61.9375em) 25.732vw, (max-width: 68.75em) 25.727vw, (max-width: 91.25em) 26.385vw, (max-width: 95.625em) 26.41vw, 404px"
            :srcset="product.srcset"
            :alt="product.title"
          />
          {{ product.title }}
        </span>
        <p v-if='product.notes' class="product-notes">{{ product.notes }}</p>
      </th>
      <td v-for='({ value }, i) of resourceTypes'>
        <template v-if=' productResources.has(value) && value !== "leadTime" '>
          <a
            :href='productResources.get(value).url'
            :class='resourceClassName(productResources.get(value).extension)'
            :target="productResources.get(value).extension.toLowerCase() === 'pdf' ? '_blank' : null"
            :rel="productResources.get(value).extension.toLowerCase() === 'pdf' ? 'noopener noreferrer' : null"
          >
            <i>{{ productResources.get(value).resourceTypeLabel }}</i>
          </a>
        </template>
        <template v-else-if=' value === "leadTime" ' >
          <p> {{ product.leadTime }} </p>
        </template>
        <template v-else>
          <p> N/A </p>
        </template>
      </td>
      <td>
        <template v-if='productResources.size > 0'>
          <a :href='product.downloadAllUrl' class='btn-download'>
            <i> All </i>
          </a>
        </template>
        <template v-else>
          <p> N/A </p>
        </template>
      </td>
    </tr>
  `
};